import { createContext, useState, useEffect } from "react"

const CartContext = createContext({
  cart: [],
  setCart: () => {},
  refreshCart: () => {},
})

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([])

  const refreshCart = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/me/cart`, {
        credentials: "include",
      })

      if (!res.ok) throw new Error("Failed to fetch cart")

      const data = await res.json()
      setCart(data)
    } catch (err) {
      console.error("Cart fetch error:", err)
    }
  }

  useEffect(() => {
    refreshCart()
  }, [])

  return (
    <CartContext.Provider value={{ cart, setCart, refreshCart }}>
      {children}
    </CartContext.Provider>
  )
}

export default CartContext
